/**
 * ticker-motion.js — одна арифметика бегущей строки для всех её мест:
 * слой «Бегущая строка» /video-watermark, титр-анимация /video-editor и табло
 * /led-scroller. До 04.11.2026 формула жила тремя копиями (блейд водяного знака,
 * overlay.js редактора, app.js табло) — три копии одной формулы расходятся молча,
 * поэтому теперь у неё один владелец и один тест (tests/js/ticker-motion.test.mjs).
 * Разбор — docs/why/ticker.md.
 *
 * Модель. Строка — лента одинаковых копий «текст + разделитель». Копия k входит
 * в кадр, когда пройденный путь off = k·period; lead = off − k·period — сколько
 * она прошла с тех пор; видна, пока 0 < lead < ширина кадра + ширина копии.
 * Влево (справа налево): x = W − lead; вправо: x = lead − span. Положение —
 * чистая функция пути, ничего не копится между кадрами: превью, покадровый
 * экспорт и полноэкранный показ рисуют одно и то же.
 *
 * Скорость — в знаках в секунду; знак ≈ 0,55 кегля. Пиксели разошлись бы между
 * превью, 720p и 4K, а «сколько успеет прочитать зритель» — единственное, ради
 * чего число нужно.
 *
 * ⚠️ Диапазоны письма справа налево — только экранами: литералы при записи
 * разлагаются (U+FB1D → U+05D9 U+05B4) и записывают в «справа налево» корейский,
 * китайский и хинди (04.11.2026).
 *
 * window.TickerMotion:
 *   CHAR_EM, SEP
 *   items(text)                       → непустые строки текста (фразы)
 *   joined(text)                      → фразы через разделитель
 *   isRtl(text)                       → письмо справа налево (арабский, иврит…)
 *   speed(cps, fontPx)                → пикселей в секунду
 *   passSec(frameW, textW, cps, fontPx) → секунд, за которые строка проходит кадр
 *   period(seamless, frameW, textW, span) → шаг между входами копий
 *   each(off, frameW, span, period, toRight, fn) → fn(x) для каждой видимой копии
 */
(function (root) {
'use strict';
if (root.TickerMotion) return;

var CHAR_EM = 0.55;
var SEP = '\u2003\u2022\u2003';
var RTL = /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;
var MAX_COPIES = 4096;

function items(text) {
    return String(text == null ? '' : text).split(/\r?\n/)
        .map(function (s) { return s.trim(); }).filter(Boolean);
}
function joined(text, sep) { return items(text).join(sep == null ? SEP : sep); }
function isRtl(text) { return RTL.test(String(text || '')); }
function speed(cps, fontPx) { return Math.max(0, Number(cps) || 0) * CHAR_EM * Math.max(0, Number(fontPx) || 0); }
function passSec(frameW, textW, cps, fontPx) {
    var v = speed(cps, fontPx);
    return v > 0 ? (frameW + textW) / v : Infinity;
}
function period(seamless, frameW, textW, span) {
    return seamless ? Math.max(1, span) : Math.max(1, frameW + textW);
}
function each(off, frameW, span, per, toRight, fn) {
    if (!(off > 0) || !(span > 0) || !(per > 0)) return 0;
    var k = Math.max(0, Math.floor((off - frameW - span) / per));
    var drawn = 0;
    for (var n = 0; n < MAX_COPIES; n++, k++) {
        var lead = off - k * per;
        if (lead <= 0) break;
        if (lead >= frameW + span) continue;
        fn(toRight ? lead - span : frameW - lead);
        drawn++;
    }
    return drawn;
}

root.TickerMotion = {
    CHAR_EM: CHAR_EM, SEP: SEP, RTL: RTL,
    items: items, joined: joined, isRtl: isRtl,
    speed: speed, passSec: passSec, period: period, each: each,
    version: '1.0.0'
};
})(typeof window !== 'undefined' ? window : globalThis);
